import { last } from 'lodash'

const timeUnitsInSeconds = {
  // seconds: 1,
  minutes: 60,
  hours: 3600,
  days: 86400,
  weeks: 604800,
  months: 2628000,
}

const unitLabelsArray = ['months', 'weeks', 'days', 'hours', 'minutes']

export const timeUnitFinder = (seconds) => {
  if (!seconds) {
    return last(unitLabelsArray)
  }

  return (
    unitLabelsArray.find((label) => {
      const unitInSeconds = timeUnitsInSeconds[label]

      return seconds % unitInSeconds === 0
    }) || last(unitLabelsArray)
  )
}

export default timeUnitsInSeconds
